import { FC, Dispatch, useEffect, useState } from "react";
import { StopEventPropagation } from "../../../helper/ui/methods";
import { UserInterface } from "../../../middleware/interfaces/user/user-interface";
import { ProjectShareInterface } from "../../../middleware/interfaces/project/project-share-interface";
import { ProjectInterface } from "../../../middleware/interfaces/project/project-interface";
import { FormatDateBE } from "../../../helper/general/methods";

interface projectShareDialogProps {
  user: UserInterface;
  selectedProject: ProjectInterface;
  reveal: boolean;
  setProjectShareDialogReveal: Dispatch<any>;
  dispatch: Dispatch<any>;
}

const ProjectShareDialog: FC<projectShareDialogProps> = ({
  user,
  selectedProject,
  reveal,
  setProjectShareDialogReveal,
  dispatch,
}) => {
  const [startSharing, setStartSharing] = useState(false);
  const [userEmails, setUserEmails] = useState("");
  const [userRoles, setUserRoles] = useState("USER");

  useEffect(() => {
    if (startSharing) {
      const projectShareData: ProjectShareInterface = {
        projectID: selectedProject.projectID!,
        projectName: selectedProject.projectName!,
        projectAccessGrantedBy: user.email,
        projectUserRole: selectedProject.projectUserRole,
        projectNewUserEmails: userEmails,
        projectNewUserRoles: userRoles,
        projectAccessDate: FormatDateBE(new Date()),
        type: "ProjectShareInterface",
      };
      dispatch({ type: "SHARE_PROJECT", payload: projectShareData });
    }
    setStartSharing(false);
    setProjectShareDialogReveal(false);
  }, [startSharing]);

  return (
    <>
      {(() => {
        if (reveal) {
          return (
            <div className="dialogCover" onClick={StopEventPropagation}>
              <div className="dialog dialogWide">
                <div className="dialogHeader">
                  <div className="dialogHeading">
                    <h2 className="dialogTitle">
                      Invite to {selectedProject.projectName}
                    </h2>
                    <span className="dialogSubtitle">
                      They receive an email invitation
                    </span>
                  </div>
                  <span
                    className="dialogClose"
                    onClick={() => setProjectShareDialogReveal(false)}
                  >
                    ×
                  </span>
                </div>
                <div className="dialogBody">
                  <div className="dialogTextInputWrapper">
                    <span className="dialogInputLabel">Email addresses</span>
                    <textarea
                      name="people"
                      placeholder="One address per line"
                      onChange={(e) => setUserEmails(e.target.value)}
                    />
                  </div>
                  <div className="dialogValueWrapper">
                    <span className="dialogInputLabel">Role</span>
                    <div id="projectShareRoleWrapper">
                      <label
                        className={
                          userRoles === "USER"
                            ? "dialogCheckRow dialogCheckRowSelected"
                            : "dialogCheckRow"
                        }
                      >
                        <input
                          type="radio"
                          name="role"
                          value="USER"
                          checked={userRoles === "USER"}
                          onChange={() => setUserRoles("USER")}
                        />
                        <span className="dialogCheckRowLabel">User</span>
                        <span className="dialogCheckRowDescription">
                          View and download contents
                        </span>
                      </label>
                      <label
                        className={
                          userRoles === "ADMIN"
                            ? "dialogCheckRow dialogCheckRowSelected"
                            : "dialogCheckRow"
                        }
                      >
                        <input
                          type="radio"
                          name="role"
                          value="ADMIN"
                          checked={userRoles === "ADMIN"}
                          onChange={() => setUserRoles("ADMIN")}
                        />
                        <span className="dialogCheckRowLabel">Admin</span>
                        <span className="dialogCheckRowDescription">
                          Also invites and deletes
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="dialogButtonWrapper">
                  <input
                    type="button"
                    name="cancelShare"
                    value="Cancel"
                    onClick={() => setProjectShareDialogReveal(false)}
                  />
                  <input
                    type="button"
                    className="dialogPrimaryButton"
                    name="startShare"
                    value="Send invites"
                    onClick={() => setStartSharing(true)}
                  />
                </div>
              </div>
            </div>
          );
        } else {
          return <></>;
        }
      })()}
    </>
  );
};

export default ProjectShareDialog;
